module.exports = __webpack_public_path__ + "static/media/support.c1793810.png";